import React from 'react';
import { UIVariant } from '@gik/ui/types';
import bemBlock from '@gik/core/utils/bemBlock';
/*
NOTE: this has been moved to _app.tsx for the nextjs app
otherwise nextjs will throw the following error:

Global CSS cannot be imported from files other than your Custom <App>. Please move all global CSS imports to src/pages/_app.tsx. Or convert the import to Component-Level CSS (CSS Modules).
Read more: https://err.sh/next.js/css-global

other apps that use the LoadingSpinner will also have to manually include this css file
*/
// import 'spinkit/spinkit.css';

// TODO: prefix this with gik- once the legacy css is adds that prefix
//  (simply remove `blockName` from the `classNames` array in the `bem` function below)
const blockName = 'loading-spinner';

export interface ILoadingSpinnerProps {
  variant?: UIVariant;
  className?: string;
  center?: boolean;
}

export default function LoadingSpinner({
  center,
  className,
  variant = 'primary',
  ...otherProps
}: ILoadingSpinnerProps) {
  const bem = bemBlock(blockName);
  return (
    <div {...otherProps} className={bem(null, [{ center }, { [variant]: true }], [className, blockName])}>
      <div className="sk-bounce">
        <div className="sk-bounce-dot" />
        <div className="sk-bounce-dot" />
      </div>
    </div>
  );
}
